import axios from 'axios';
import authHeader from '@/services/auth.header';
import { HTTP } from '@/http/config'; 
import { AnyObject } from 'yup';
import {IUsers} from '../interfaces/IUsers';
const API_URL = HTTP.api_url;

class UserService {
  
  async getIndexUser():Promise<AnyObject>{    
   const response = await axios.get(API_URL + 'users', { headers: authHeader() })
    .then(response => {        
      //console.log(JSON.stringify(response.data.data))
      return response?.data.data;
    }).catch(error => {
      const dataError = JSON.stringify(error.response.data)
      console.log(dataError)      
    });
    return  response;
  }

  async getlist(pageNumber):Promise<AnyObject>{    
   const response = await axios.get(API_URL + `users?page=${pageNumber}`, { headers: authHeader() })
    .then(response => {             
      return response?.data;
    }).catch(error => {
      const dataError = JSON.stringify(error.response.data)
      console.log(dataError)      
    });
    return  response;
  }
   async getSearch(search):Promise<AnyObject>{    
   const response = await axios.get(API_URL + `users`, 
    { 
      params: search,
      headers: authHeader() 
    })
    .then(response => {              
      return response?.data;
    }).catch(error => {
      const dataError = JSON.stringify(error.response.data)
      console.log(dataError)      
    });
    return  response;
  }

  async postCreated(user):Promise<AnyObject> {    
    const response = await axios.post(API_URL + 'users', 
      user, 
      { headers: authHeader() }
    )
    .then(response =>{
     // console.log(response.data)
      return response?.data;
    })
    .catch(error=>{
      const dataError = error.response.data
      console.log(dataError)   
      return dataError;
    });
    return response;
  }

  async postUpdate(id,user):Promise<AnyObject> {    
    const response = await axios.put(API_URL + `users/${id}`,  
      {id:Number(id),...user},     
      { headers: authHeader() },      
    )
    .then(response =>{
      //console.log(response.data)
      return response?.data;
    })
    .catch(error=>{
      const dataError = error.response.data
      console.log(dataError)   
      return dataError;
    });
    return response;
  }

  async getEdit(id):Promise<IUsers[]>{
     const response = await axios.get(API_URL + `users/${id}`,     
      { headers: authHeader() }
    )
    .then(response =>{     
      return response?.data;
    })
    .catch(error=>{
      const dataError = error.response.data
      console.log(dataError)   
      return dataError;
    });
    return response;
  }

   async getDelete(id):Promise<AnyObject>{
     const response = await axios.delete(API_URL + `users/${id}`,     
      { headers: authHeader() }
    )
    .then(response =>{      
      return response?.data;
    })
    .catch(error=>{
      const dataError = error.response.data
      console.log(dataError)   
      return dataError;
    });
    return response;
  }
  async postChangedPass(id,users):Promise<AnyObject>{
    const response = await axios.post(API_URL+`users/changed/${id}`,
      {id:Number(id),...users},
      { headers: authHeader() }
    )
    .then(response =>{      
      return response?.data;
    })
    .catch(error=>{
      const dataError = error.response.data
      console.log(dataError)   
      return dataError;
    });
    return response;
    
  }
  
  getPublicContent() {
    return axios.get(API_URL + 'all');
  }

  getUserBoard() {
    return axios.get(API_URL + 'users', { headers: authHeader() });
  }

  getModeratorBoard() {
    return axios.get(API_URL + 'mod', { headers: authHeader() });
  }

  getAdminBoard() {
    return axios.get(API_URL + 'admin', { headers: authHeader() });
  }  
}

export default new UserService();